/**
 * 教师信息
 */
class LearningTeacher {
  /**
   * 教师编号
   */
  id = ''
  /**
   * 教师名称
   */
  name = ''
  /**
   * 教师头像
   */
  photo = ''
  /**
   * 教师简介
   */
  abouts = ''
  /**
   * 性别，-1表示未知，0表示女，1表示男
   */
  gender = -1
  /**
   * 职称
   */
  professionalTitle = ''
}

export default LearningTeacher
